import React from 'react';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import EmptyState from '../../../shared/empty_state';

export default function NoLeads({ bodyText }) {
  return (
    <EmptyState bodyText={bodyText} header="You have not created any leads" icon={faExclamationCircle}/>
  );
}

NoLeads.propTypes = {
  bodyText: PropTypes.string,
  emptyLeadsImage: PropTypes.string
};
